import type { IconName, PhosphorIconName, PhosphorWeight } from './types'

const iconSizes = {
  // biome-ignore lint/complexity/useLiteralKeys: Bulk suppression as part of biome migration
  ['small']: 'h-[12px] w-[12px]',
  // biome-ignore lint/complexity/useLiteralKeys: Bulk suppression as part of biome migration
  ['medium']: 'h-[14px] w-[14px]',
  // biome-ignore lint/complexity/useLiteralKeys: Bulk suppression as part of biome migration
  ['large']: 'h-[16px] w-[16px]',
  // biome-ignore lint/complexity/useLiteralKeys: Bulk suppression as part of biome migration
  ['x-large']: 'h-[40px] w-[40px]',
}

export interface IconBaseProps {
  className?: string
  iconName: IconName | PhosphorIconName
  size?: 'small' | 'medium' | 'large' | 'x-large'
  onClick?: () => void
}

export function IconBase({
  IconComponent,
  iconName,
  size = 'large',
  type,
  className,
  onClick,
  weight,
  ...props
}: IconBaseProps & {
  IconComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>
  type: 'solid' | 'outline' | 'phosphor'
  weight?: PhosphorWeight
}) {
  // biome-ignore lint/suspicious/noExplicitAny: Bulk suppression as part of biome migration
  const iconProps: any = {
    className: `${className ?? ''} ${iconSizes[size]}`,
    'aria-hidden': 'true',
    'data-testid': `${iconName}-${type}`,
    onClick,
    ...props,
  }

  // Only add weight prop for phosphor icons
  if (type === 'phosphor' && weight) {
    iconProps.weight = weight
  }

  return <IconComponent {...iconProps} />
}
